import React from 'react';

import { node } from 'prop-types';

import { faBrain } from '@fortawesome/pro-regular-svg-icons/faBrain';
import { faMasksTheater } from '@fortawesome/pro-regular-svg-icons/faMasksTheater';
import { faStethoscope } from '@fortawesome/pro-regular-svg-icons/faStethoscope';
import { faUsers } from '@fortawesome/pro-regular-svg-icons/faUsers';

import FontAwesomeIcon from 'components/Common/FontAwesomeIcon';

import v from 'components/variables';

export const OVERALL_CATEGORY = 'Overall';

export const CHECKINS_ANSWER_CATEGORIES = [
  'Emotional',
  'Physical',
  'Social',
  'Cognitive',
];

export const CHECKINS_ANSWER_CATEGORIES_WITH_OVERALL = [
  OVERALL_CATEGORY,
  ...CHECKINS_ANSWER_CATEGORIES,
];

const ICON_SIZE = 20;

const IconWrapper = ({ children }) => (
  <svg width={ICON_SIZE} height={ICON_SIZE}>
    {children}
  </svg>
);

IconWrapper.propTypes = {
  children: node.isRequired,
};

// Should have same values as in CHECKINS_ANSWER_CATEGORIES
export const CHECKINS_ANSWER_CATEGORIES_MAP = Object.freeze({
  Emotional: (
    <IconWrapper>
      <FontAwesomeIcon icon={faMasksTheater} />
    </IconWrapper>
  ),
  Social: (
    <IconWrapper>
      <FontAwesomeIcon icon={faUsers} />
    </IconWrapper>
  ),
  Physical: (
    <IconWrapper>
      <FontAwesomeIcon icon={faStethoscope} />
    </IconWrapper>
  ),
  Cognitive: (
    <IconWrapper>
      <FontAwesomeIcon icon={faBrain} />
    </IconWrapper>
  ),
});

export const CHECKINS_ANSWER_WEIGHTING_MAP = Object.freeze({
  1: {
    name: 'positive',
    color: {
      normal: v.greenLight,
      medium: v.greenMedium,
      extraLight: v.greenExtraLight,
    },
  },
  0: {
    name: 'neutral',
    color: {
      normal: v.yellowLight,
      medium: v.yellowMedium,
      extraLight: v.yellowExtraLight,
    },
  },
  '-1': {
    name: 'negative',
    color: {
      normal: v.redLight,
      medium: v.redMedium,
      extraLight: v.redExtraLight,
    },
  },
});

export const CHECKINS_ANSWER_WEIGHTINGS = Object.freeze({
  NEGATIVE: -1,
  NEUTRAL: 0,
  POSITIVE: 1,
});

export const CHECKINS_ANSWER_WEIGHTING_ORDER = Object.keys(
  CHECKINS_ANSWER_WEIGHTING_MAP,
)
  .sort()
  .reverse();
